import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'common/components/Icon';
import Button from 'common/components/Button';
import Typography from 'common/components/Typography';
import colors from 'common/styles/colors';
import { rewardsSupportUrl } from 'common/constants';

import styles from './index.module.css';

const NextRewardRateCard = ({ rate, description }) => (
  <div className={styles.root}>
    <div className={styles.content}>
      <div className={styles.header}>
        <Icon.Gift
          className={styles.giftIcon}
          description="Gift icon"
          size="medium"
          fill={colors['rebranding-md-color-brand-purple']}
        />
        <Typography
          tag="h2"
          size="base"
          weight="semiBold"
          color="color-neutral-900"
        >
          Next reward rate
        </Typography>
        <div className={styles.rateBadge}>
          <Icon.TrendUp
            className={styles.trendUpIcon}
            description="Trend up"
            size="xSmall"
            fill={colors['color-green-900']}
          />
          <Typography
            tag="div"
            size="xs"
            weight="semiBold"
            color="color-green-900"
          >
            {rate}
          </Typography>
        </div>
      </div>
      <div className={styles.footer}>
        <Typography tag="div" size="sm" color="color-neutral-400">
          {description}
        </Typography>
        <div className={styles.learnMoreButtonWrapper}>
          <Button kind="secondary" size="small">
            <a
              href={rewardsSupportUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Learn more
              <Icon.NewTab
                className={styles.externalLinkIcon}
                description="External link"
                size="xSmall"
                fill={colors['rebranding-md-color-brand-black']}
              />
            </a>
          </Button>
        </div>
      </div>
    </div>
  </div>
);

NextRewardRateCard.propTypes = {
  rate: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default NextRewardRateCard;
